var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGatewayIcon = function SvgGatewayIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 8,
    x: 5.167,
    y: 4,
    stroke: "#697477",
    strokeWidth: 1.5,
    rx: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#697477",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.08 9.313 1.668 7.9 3.08 6.485M14.08 9.313 15.496 7.9l-1.414-1.414M10.667 2h-4M10.667 14h-4"
  })));
};
export { SvgGatewayIcon as ReactComponent };
export default __webpack_public_path__ + "d2ef717ef7611a652528fd73fe477d79.svg";